import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export default function CustomerInformation() {
  const [customerData, setCustomerData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const token = sessionStorage.getItem('userToken');
        
        if (!token) {
          throw new Error('Token not found');
        }
        
        const decodedToken = jwtDecode(token);
        
        if (decodedToken.exp < Date.now() / 1000) {
          throw new Error('Token expired');
        }

        const user = JSON.parse(localStorage.getItem('user'));
        
        if (user && user.email) {
          const response = await axios.get(`https://fboothapi.azurewebsites.net/api/account/email/${user.email}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setCustomerData(response.data);
          setLoading(false);
        } else {
          setError('User not found in session');
          setLoading(false);
        }
      } catch (err) {
        setError('Error fetching customer data or session expired');
        setLoading(false);
        navigate('/'); // Redirect to homepage if there is an error
      }
    };

    fetchCustomerData();
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/');
  };

  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-blue-100">
      <div className="text-center">
        <div className="loader ease-linear rounded-full border-8 border-t-8 border-blue-200 h-64 w-64 mb-4"></div>
        <h2 className="text-center text-blue-600 text-xl font-semibold">Loading...</h2>
        <p className="text-blue-500">Please wait a second</p>
      </div>
    </div>
  );

  if (error) return <div>{error}</div>;

  return (
    <div className="flex min-h-screen bg-gray-50">
      <aside className="w-64 bg-gray-100 p-6 border-r border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Profile settings</h2>
        <nav className="mt-8">
          <ul className="space-y-2">
            <li>
              <Link to="/profile" className="text-blue-500 flex items-center">
                <span className="mr-2"></span> Personal details
              </Link>
            </li>
            <li>
              <Link to="/history" className="text-gray-700 flex items-center">
                <span className="mr-2"></span> History
              </Link>
            </li>
          </ul>
        </nav>
      </aside>

      <main className="flex-1 bg-white p-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-8">Personal details</h2>

        {customerData && (
          <div className="space-y-6">
            <div className="flex items-center">
              <img
                src={require('../../assets/3.jpeg')}
                alt="Profile"
                className="w-16 h-16 rounded-full"
              />
              <div className="ml-6">
                <h3 className="text-2xl font-semibold text-gray-900">{`${customerData.firstName} ${customerData.lastName}`}</h3>
                <Link
                  to="/editprofile"
                  className="text-blue-500 hover:text-blue-700 text-lg"
                >
                  Edit profile
                </Link>
              </div>
            </div>

            <div className="mx-24 border-t border-gray-200 pt-4">
              <div className="flex justify-between py-3">
                <span className="text-xl font-medium text-gray-700">Full name</span>
                <div className="flex items-center">
                  <span className="text-xl text-gray-900">{`${customerData.firstName} ${customerData.lastName}`}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-xl font-medium text-gray-700">Location</span>
                <div className="flex items-center">
                  <span className="text-xl text-gray-900">{customerData.address}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-xl font-medium text-gray-700">Email</span>
                <div className="flex items-center">
                  <span className="text-xl text-gray-900">{customerData.email}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-xl font-medium text-gray-700">Nationality</span>
                <div className="flex items-center">
                  <span className="text-xl text-gray-900">{customerData.nationality || 'Not provided'}</span>
                </div>
              </div>
              <div className="flex justify-between py-3">
                <span className="text-xl font-medium text-gray-700">Date of birth</span>
                <div className="flex items-center">
                  <span className="text-xl text-gray-900">{new Date(customerData.dateOfBirth).toLocaleDateString()}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
